import { inject } from 'vue';
import LivePlayer from './player';

export const livePlayerKey = Symbol.for('livePlayer');

export default function(): LivePlayer {
  return inject<LivePlayer>(livePlayerKey)!;
}
